module.exports = __webpack_public_path__ + "assets/img/times.c9e91c3c.svg";